var render = function render(){var _vm=this,_c=_vm._self._c;return _c('goal-settings-content',{attrs:{"widget-type":"gift-goal","entity-name":"dono goal","count-field":"amount","number-type":"float","round-count-on-load":"","ignore-subscription-error":""},on:{"loading":function($event){return _vm.$emit('loading', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }